import Input from "../../../../Core/Fields/Floating/Input";

const GeneralDetails = ({ formData, errors }) => {
  return (
     <div className="row mb-3" style={{ border: "1px solid #00000059", borderRadius: "5px" }}>
      <div className="col-12">
        <p className="boxLabel m-0">General Details</p>
      </div>
      
      {/* Row 1 */}
      <div className="col-3">
        <div className="mb-3">
          <Input
            id="companyName"
            label="Company Name"
            style={{ height: "30px", border: errors.companyName ? "1px solid red" : "" }}
            value={formData.companyName}
            readOnly
          />
        </div>
      </div>
      
      <div className="col-3">
        <div className="mb-3">
          <Input
            id="abbreviation"
            label="Abbreviation"
            readOnly
            style={{ height: "30px" }}
            value={formData.abbreviation}
          />
        </div>
      </div>
      
      <div className="col-3">
        <div className="mb-3">
           <Input
            id="DefaultCurrency"
            label="Default Currency"
            readOnly
            style={{ height: "30px" }}
            value={formData.defaultCurrency}
          />
        
        </div>
      </div>
      
      <div className="col-3">
        <div className="mb-3">
           <Input
            id="abbreviation"
            label="Country"
            readOnly
            style={{ height: "30px" }}
            value={formData.country}
          />
      
        </div>
      </div>

      <div className="col-4">
        <div className="mb-3">
           <Input
            id="abbreviation"
            label="Default GST Rate"
            readOnly
            style={{ height: "30px" }}
            value={formData.defaultGSTRate}
          />
         
          <p className="m-0" style={{fontSize:'10px',paddingLeft:'3px'}} >Sales / Purchase Taxes and Charges Template will be created based on this GST Rate</p>
        </div>
      </div>

      <div className="col-4">
        <div className="mb-3">
           <Input
            id="abbreviation"
            label="Default Holiday List"
            readOnly
            style={{ height: "30px" }}
            value={formData.defaultHolidayList}
          />

        </div>
      </div>

      <div className="col-4">
        <div className="mb-3">
           <Input
            id="abbreviation"
            label="Default Letter Head"
            readOnly
            style={{ height: "30px" }}
            value={formData.defaultLetterHead}
          />
        
        </div>
      </div>

      {/* Row 3 */}
      <div className="col-3">
        <div className="mb-3">
          <Input
            id="domain"
            readOnly
            label="Domain"
            style={{ height: "30px" }}
            value={formData.domain}
          />
        </div>
      </div>

      <div className="col-3">
        <div className="mb-3">
          <Input
            id="taxID"
            label="Tax ID"
            readOnly
            style={{ height: "30px" }}
            value={formData.taxID}
          />
        </div>
      </div>

      <div className="col-3">
        <div className="mb-3">
           <Input
            id="abbreviation"
            label="Date of Establishment"
            readOnly
            style={{ height: "30px" }}
            value={formData.dateOfEstablishment}
          />
          
        </div>
      </div>

      <div className="col-3">
        <div className="mb-3">

           <Input
            id="abbreviation"
            label="Parent Company"
            readOnly
            style={{ height: "30px" }}
            value={formData.parentCompany}
          />
          
        </div>
      </div>


      <div className="col-3">
        <div className="mb-3">
          <input type="checkbox" readOnly checked={formData.isgroup} name="IsGroup" className="form-check-input" style={{backgroundColor:'#270b79',borderColor:'#270b79'}}  id="" />
          <label htmlFor="IsGroup" style={{fontSize:'0.9rem',position:'relative',top:'-2px',paddingLeft:'3px'}}>Is Group</label>
        </div>
      </div>
    </div>
  );
};

export default GeneralDetails;
